import { useRef, useState, useEffect, useContext } from 'react'
import { useNavigate, redirect } from 'react-router-dom'
import axios from 'axios'
import Header from './Header';
import Footer from './Footer';

const News = () => {
  const server_app_api = window.SERVER_APP_API
  const server_app_api_php = window.SERVER_APP_API_PHP

  /*********The Counter To Refresh The Data Info Views Starts Here*****************/
  let [count, setCount] = useState(0)
  let counts = 0
  let countz = 0
  let delay = 360000
  setInterval(() => {
    setCount(count + 1)
  }, delay)
  /*********The Counter To Refresh The Data Info Views Ends Here**********************/

  const [newsItems, setNewsItems] = useState([]);
  const [expandedNews, setExpandedNews] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const fetchNews = async () => {
    const formData = new FormData();
    formData.append('apiType', 'get-news');
    try {
      const response = await axios.post(`${server_app_api_php}/server/index.php`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setNewsItems(response.data);
    } catch (error) {
      console.log('An error occurred while retrieving news items.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);

  const toggleContentLatestNews = (index) => {
    setExpandedNews(prevState => ({
      ...prevState,
      [index]: !prevState[index]
    }));
  };

  return (
    <>
      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
        <Header />
        
        <main className="pt-24">
          <div className="max-w-7xl mx-auto px-4 py-8">
            {/* Header */}
            <div className="text-center mb-12">
              <h1 className="text-4xl font-bold text-gray-800 mb-4">Woodlands Conference AY News</h1>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Stay updated with the latest news, events, and activities from our youth ministries.
              </p>
            </div>

            {/* Loading State */}
            {isLoading ? (
              <div className="flex flex-col items-center justify-center py-20">
                <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-4"></div>
                <p className="text-gray-600">Loading news articles...</p>
              </div>
            ) : newsItems.length > 0 ? (
              <div className="space-y-8">
                {newsItems.map((news, index) => (
                  <div key={index} className="bg-white rounded-2xl shadow-xl overflow-hidden transform hover:shadow-2xl transition-all duration-300">
                    <div className="md:flex">
                      {/* Media Column */}
                      <div className="md:w-2/5 relative">
                        {news.media_urlsVideos.length < 1 && news.media_urlsImages.length > 0 ? (
                          <div className="relative h-64 md:h-full">
                            <img
                              src={server_app_api_php + '/server/' + news.media_urlsImages[0]}
                              className="w-full h-full object-cover"
                              alt="News"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                          </div>
                        ) : news.media_urlsVideos.length > 0 ? (
                          <div className="relative h-64 md:h-full">
                            <video
                              className="w-full h-full object-cover"
                              controls
                            >
                              <source src={server_app_api_php + '/server/' + news.media_urlsVideos[0]} />
                              Your browser does not support the video tag.
                            </video>
                          </div>
                        ) : (
                          <div className="h-64 md:h-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
                            <svg className="w-16 h-16 text-white/80" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                            </svg>
                          </div>
                        )}
                        
                        {/* News Badge */}
                        <div className="absolute top-4 left-4">
                          <span className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-3 py-1 rounded-full text-sm font-semibold shadow-lg">
                            News
                          </span>
                        </div>
                      </div>

                      {/* Content Column */}
                      <div className="md:w-3/5 p-6 md:p-8">
                        <div className="flex items-center text-gray-500 text-sm mb-4">
                          <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                          </svg>
                          <span>{new Date().toLocaleDateString()}</span>
                        </div>

                        <h3 className="text-2xl font-bold text-gray-800 mb-4 hover:text-blue-600 transition-colors duration-300">
                          {news.title}
                        </h3>

                        <div className="text-gray-600 leading-relaxed mb-6">
                          <p>
                            {expandedNews[index] ? news.description : news.description.split(' ').slice(0, 30).join(' ')}
                            {news.description.split(' ').length > 30 && (
                              <button
                                onClick={() => toggleContentLatestNews(index)}
                                className="ml-2 text-blue-600 hover:text-blue-800 font-semibold transition-colors duration-300"
                              >
                                {expandedNews[index] ? 'Show Less' : 'Read More'}
                              </button>
                            )}
                          </p>
                        </div>

                        {/* Additional Media */}
                        {expandedNews[index] && (
                          <div className="mt-6 space-y-4">
                            {news.media_urlsImages.slice(1).map((urlImage, indexImage) => (
                              <div key={indexImage} className="relative group">
                                <img
                                  src={server_app_api_php + '/server/' + urlImage}
                                  alt={`News ${indexImage + 1}`}
                                  className="rounded-lg shadow-md w-full object-cover"
                                />
                              </div>
                            ))}
                            
                            {news.media_urlsVideos.slice(1).map((urlVideo, indexVideo) => (
                              <div key={indexVideo} className="relative">
                                <video
                                  className="rounded-lg shadow-md w-full"
                                  controls
                                >
                                  <source src={server_app_api_php + '/server/' + urlVideo} />
                                  Your browser does not support the video tag.
                                </video>
                              </div>
                            ))}
                          </div>
                        )}

                        {/* Action Buttons */}
                        <div className="flex items-center justify-between mt-6 pt-6 border-t border-gray-200">
                          <div className="flex space-x-2" hidden>
                            <button className="flex items-center space-x-1 text-gray-500 hover:text-blue-600 transition-colors duration-300">
                              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                              </svg>
                              <span>Like</span>
                            </button>
                            
                            <button className="flex items-center space-x-1 text-gray-500 hover:text-green-600 transition-colors duration-300">
                              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M10 16l-5-5 1.41-1.41L10 13.17l7.59-7.59L19 7l-9 9zm-7 3h14v-2H3v2z"/>
                              </svg>
                              <span>Share</span>
                            </button>
                          </div>
                          
                          <button className="text-blue-600 hover:text-blue-800 font-semibold transition-colors duration-300">
                            Full Story →
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="bg-white rounded-2xl shadow-lg p-12 text-center">
                <div className="w-24 h-24 mx-auto mb-6 bg-gradient-to-r from-blue-100 to-purple-100 rounded-full flex items-center justify-center">
                  <svg className="w-12 h-12 text-blue-400" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-700 mb-3">No News Available</h3>
                <p className="text-gray-500 max-w-md mx-auto">
                  There are no news articles available at the moment. Please check back later for updates.
                </p>
              </div>
            )}

            {/* Newsletter Subscription */}
            <div className="mt-12 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 text-white">
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold mb-3">Subscribe to Our Newsletter</h3>
                <p className="text-blue-100 max-w-md mx-auto">
                  Get the latest news and updates directly in your inbox.
                </p>
              </div>
              
              <div className="max-w-md mx-auto">
                <div className="flex gap-3">
                  <input
                    type="email"
                    placeholder="Enter your email"
                    className="flex-1 px-4 py-3 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-white"
                  />
                  <button className="bg-white text-blue-600 px-6 py-3 rounded-lg hover:bg-gray-100 transition-all duration-300 font-semibold">
                    Subscribe
                  </button>
                </div>
                <p className="text-blue-100 text-sm text-center mt-3">
                  We respect your privacy. Unsubscribe at any time.
                </p>
              </div>
            </div>

            {/* News Categories */}
            <div className="mt-12 bg-white rounded-2xl shadow-lg p-8" hidden>
              <h3 className="text-2xl font-bold text-gray-800 mb-6">News Categories</h3>
              
              <div className="grid md:grid-cols-4 gap-4">
                {[
                  { name: 'Events', count: '12', color: 'bg-gradient-to-r from-blue-500 to-cyan-500' },
                  { name: 'Ministry', count: '8', color: 'bg-gradient-to-r from-purple-500 to-pink-500' },
                  { name: 'Youth', count: '15', color: 'bg-gradient-to-r from-emerald-500 to-green-500' },
                  { name: 'Updates', count: '6', color: 'bg-gradient-to-r from-amber-500 to-orange-500' }
                ].map((category, idx) => (
                  <div key={idx} className="p-4 rounded-xl border border-gray-200 hover:border-blue-300 transition-colors duration-300 cursor-pointer">
                    <div className="flex items-center justify-between mb-2">
                      <span className="font-semibold text-gray-700">{category.name}</span>
                      <span className={`${category.color} text-white text-xs px-2 py-1 rounded-full`}>
                        {category.count}
                      </span>
                    </div>
                    <p className="text-sm text-gray-500">Latest news and updates</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Stats */}
            <div className="mt-12 bg-gradient-to-r from-gray-800 to-gray-900 rounded-2xl p-8">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-white mb-2">{newsItems.length}</div>
                  <div className="text-gray-300">Total Articles</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-white mb-2">
                    {newsItems.filter(n => n.media_urlsImages?.length > 0).length}
                  </div>
                  <div className="text-gray-300">With Images</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-white mb-2">
                    {newsItems.filter(n => n.media_urlsVideos?.length > 0).length}
                  </div>
                  <div className="text-gray-300">With Videos</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-white mb-2">24/7</div>
                  <div className="text-gray-300">Updates</div>
                </div>
              </div>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  )
}

export default News